module.exports = __webpack_public_path__ + "img/img10.c7a79e6a.png";